import { render, staticRenderFns } from "./ListNvo.vue?vue&type=template&id=969217bc&"
import script from "./ListNvo.vue?vue&type=script&lang=js&"
export * from "./ListNvo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports